export enum ConversationParticipantSummaryChannel {
  sms = 'sms',
  chat = 'chat',
  whatsApp = 'whatsApp',
}

export type ConversationParticipantSummaryChannelType = keyof typeof ConversationParticipantSummaryChannel;
